<template>
	
	<div>
		<!-- <div class="input-holder"> -->
				<input type="text" v-validate="'required'" v-model.lazy="current_program.name" name="program_name" class="no-border font-size-20"  placeholder="Program Name"/>
				<div class="mt-3">
					<div class="font-size-14">
						Notes
						<a @click="show_notes = !show_notes">
							<i class="fa fa-expand toogle-icon float-right">
							</i>
						</a>

					</div>
					<textarea v-if="show_notes" type="text" v-model.lazy="current_program.notes" name="notes" class="no-border font-size-14"  placeholder="Program Notes"/>

				</div>
		<!-- </div> -->
	</div>
</template>
<script>

export default {
	props:['current_program'],

	data : function() {
		return{
			show_notes: false
		}
	},
    watch:{
        'current_program.name': function(val){
            this.$emit('updateProgram')
        },
        'current_program.notes': function(val){
            this.$emit('updateProgram')
        }
    },
	created : function(){

	},
	methods : {
		
	}
}
</script>
<style scoped src="./Shopify.css"></style>


// WEBPACK FOOTER //
// src/components/shopify/ShopifyProgramName.vue